module.exports = __webpack_public_path__ + "static/img/eisbecher-lila.7671dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eisbecher-lila.jpg
// module id = +a1a
// module chunks = 0